import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f9f9f9', py: 8 }}>
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/')}
          sx={{ mb: 4, color: '#9c4f96' }}
        >
          Voltar para o site
        </Button>

        <Box sx={{ bgcolor: 'white', p: 4, borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, color: '#9c4f96', mb: 4 }}>
            Política de Privacidade
          </Typography>

          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 4 }}>
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            1. Informações que Coletamos
          </Typography>
          <Typography variant="body1" paragraph>
            Coletamos as seguintes informações quando você agenda uma consulta através do nosso site:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Nome completo</li>
            <li>Telefone de contato</li>
            <li>Endereço de e-mail (opcional)</li>
            <li>Data e horário preferencial para consulta</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            2. Como Utilizamos suas Informações
          </Typography>
          <Typography variant="body1" paragraph>
            Os dados coletados são utilizados exclusivamente para:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Confirmar e gerenciar agendamentos de consultas</li>
            <li>Entrar em contato para confirmação, lembretes ou reagendamentos</li>
            <li>Manter o histórico de atendimentos (conforme Código de Ética Odontológica - Art. 17)</li>
            <li>Cumprir obrigações legais e regulatórias da profissão</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            3. Proteção de Dados e Sigilo Profissional
          </Typography>
          <Typography variant="body1" paragraph>
            Em conformidade com o <strong>Código de Ética Odontológica (Art. 14)</strong> e a 
            <strong> Lei Geral de Proteção de Dados (LGPD - Lei 13.709/2018)</strong>, garantimos:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Sigilo absoluto sobre todas as informações de saúde e dados pessoais</li>
            <li>Acesso restrito aos dados apenas por profissionais autorizados</li>
            <li>Não compartilhamento de dados com terceiros sem autorização expressa</li>
            <li>Armazenamento seguro em sistemas protegidos</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            4. Seus Direitos
          </Typography>
          <Typography variant="body1" paragraph>
            Conforme a LGPD, você tem direito a:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Confirmar a existência de tratamento dos seus dados</li>
            <li>Acessar seus dados pessoais</li>
            <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
            <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</li>
            <li>Revogar o consentimento a qualquer momento</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            5. Retenção de Dados
          </Typography>
          <Typography variant="body1" paragraph>
            Os dados serão mantidos pelo período necessário para:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Cumprimento de obrigações legais e regulatórias (mínimo de 20 anos conforme Resolução CFO-118/2012)</li>
            <li>Continuidade do cuidado odontológico</li>
            <li>Defesa de direitos em processos administrativos ou judiciais</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            6. Cookies e Tecnologias Similares
          </Typography>
          <Typography variant="body1" paragraph>
            Este site utiliza tecnologias básicas de navegação (cookies) apenas para garantir 
            o funcionamento adequado do sistema de agendamento. Não utilizamos cookies de 
            rastreamento ou publicidade.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            7. Contato
          </Typography>
          <Typography variant="body1" paragraph>
            Para exercer seus direitos ou esclarecer dúvidas sobre esta Política de Privacidade, 
            entre em contato:
          </Typography>
          <Typography variant="body1" component="div" sx={{ pl: 3 }}>
            <strong>Thayne Silva Prado</strong><br />
            Cirurgiã-Dentista — CRO/PR 38004<br />
            E-mail: contato@tsodonto.com.br<br />
            Telefone: (42) 99872-0555
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            8. Alterações nesta Política
          </Typography>
          <Typography variant="body1" paragraph>
            Esta Política de Privacidade pode ser atualizada periodicamente. A data da última 
            atualização será sempre indicada no topo desta página.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;